class CookieNotification {
  constructor() {
    this.props = {
      cookie: document.querySelector('.cookie')
    }
    this.bind()
  }
  bind() {
    const { cookie } = this.props

    if (cookie) {
      cookie.classList.add('cookie--show')
      const cookieButton = cookie.querySelector('.js-cookie-confirm')
      const cookieDeny = cookie.querySelector('.js-cookie-deny')
      
      if (cookieButton) {
        cookieButton.addEventListener('click', e => {
          e.preventDefault()

          this.setCookie('cookieNotification')

          cookie.classList.add('cookie--hide')
        })
      }
      if (cookieDeny) {
        cookieDeny.addEventListener('click', e => {
          e.preventDefault()

          cookie.classList.add('cookie--hide')
        })
      }
    }
  }
  setCookie(name, expires) {
    const date = new Date()
    date.setTime((date.getTime() + (360 * 24 * 60 * 60 * 1000)))

    let expiresVal = (expires === undefined ? "; expires=" + date.toUTCString() : expiresVal = expires)

    document.cookie = `${name}=1;${expiresVal}; path=/`
  }
  removeCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  }
}

export default CookieNotification
